/** Lobby in-app view path segment (under `/lobby/:slug/...`). */
export type LobbyViewSlug = 'mygames';

const MY_GAMES_SLUG: LobbyViewSlug = 'mygames';

/** True when the current router pathname is the My Games deep-link. */
export function isLobbyMyGamesPath(pathname: string): boolean {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  return normalized === `/${MY_GAMES_SLUG}` || normalized.endsWith(`/${MY_GAMES_SLUG}`);
}

/**
 * Build a basename-relative lobby path.
 * Examples (basename = `/tenant/dk`):
 * - `buildLobbyViewPath('default')` → `/lobby/default`
 * - `buildLobbyViewPath('default', 'mygames')` → `/lobby/default/mygames`
 * - `buildLobbyViewPath(undefined)` → `/`
 * - `buildLobbyViewPath(undefined, 'mygames')` → `/mygames`
 */
export function buildLobbyViewPath(lobbySlug: string | undefined, view?: LobbyViewSlug): string {
  if (!lobbySlug) {
    return view === MY_GAMES_SLUG ? `/${MY_GAMES_SLUG}` : '/';
  }
  const base = `/lobby/${lobbySlug}`;
  return view === MY_GAMES_SLUG ? `${base}/${MY_GAMES_SLUG}` : base;
}

/** Preserve current query string when switching lobby views. */
export function withSearch(path: string, search: string): string {
  if (!search || search === '?') return path;
  return `${path}${search.startsWith('?') ? search : `?${search}`}`;
}
